import React, { FC, useState } from "react";
import { MainInfoCard } from "src/page-components/clones/[clone]/MainInfoCard";
import { ViewersLabel } from "src/components/Card/ViewersLabel";
import { AddToFavorite } from "src/components/Card/AddToFavoriteButton/AddToFavorite";
import { IClone } from "src/@types/clones";
import { Show } from "src/components/PrivateRoute/Show";
import { ONLY_FOR } from "src/components/PrivateRoute/types";

export const HeaderClone: FC<IClone> = ({ ...clone }) => {
  const { id, isFavorite, company_name, views_count, saved_count } = clone;

  const [isFavoriteClone, setIsFavoriteClone] = useState(isFavorite);

  return (
    <>
      <div className="md:flex items-center justify-between">
        <h1 className="font-semibold">{company_name}</h1>

        <div className="flex mt-5 md:mt-0 gap-5">
          <ViewersLabel viewsCount={views_count} />

          <Show onlyFor={ONLY_FOR.AGENT}>
            <AddToFavorite
              id={id}
              saved_count={saved_count}
              isFavorite={isFavoriteClone}
              setIsFavorite={setIsFavoriteClone}
            />
          </Show>
        </div>
      </div>

      <MainInfoCard
        clone={clone}
        isFavorite={isFavoriteClone}
        setIsFavorite={setIsFavoriteClone}
      />
    </>
  );
};
